import { Swiper } from 'swiper'
import {
  Navigation,
  Pagination,
} from 'swiper/modules'

if ($('.js-reviewsSlider').length > 0) {
  new Swiper('.js-reviewsSlider', {
    modules: [Navigation, Pagination],
    spaceBetween: 5,
    lockClass: 'is-hidden',
    autoHeight: true,
    pagination: {
      el: '.reviews-current',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.reviews-button-next',
      prevEl: '.reviews-button-prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 11,
      },
      1024: {
        spaceBetween: 20,
      },
    },
    on: {
      init: function (swiper) {
        if (swiper.slides.length > 1) {
          swiper.navigation.prevEl[0].style.display = 'flex'
          swiper.navigation.nextEl[0].style.display = 'flex'
        }
      },
    }
  })  
}
